/**
 * The ChangePasswordError Code.
 */
export type ChangePasswordErrorCode =
    | 'permissionDenied' // only the user can change it own password
    | 'invalidPassword' // the current password is invalid
    | 'newAndConfirmationPasswordDoNotMatch' // The new and confirmation password are not equal
    | 'passwordInsecure' // the password don't have the necessary length/chars to be considered secure
    | 'passwordAlreadyUsed' // the password has already been used by the user
    | 'passwordContainsUserData' // the password contains segments that match some user data (name / email)
    | 'tokenExpired' // the change password token has expired
    | 'unknown'; // self explanatory

/**
 * Error thrown when the login is not performed successfully
 *
 * @export
 */
export class ChangePasswordError implements Error {
    /** The Error Name */
    get name(): string {
        return 'ChangePasswordError';
    }

    /** The Error Message */
    message: string;

    /** The Error Code */
    code: ChangePasswordErrorCode;

    constructor(code: ChangePasswordErrorCode, message: string) {
        this.message = message;
        this.code = code;
    }
}
